module.exports = __webpack_public_path__ + "24a0227fbdd3acfd86ff03fc3fc6c8a4.png";